import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CreateFormAiHandoffService {
  private readonly pendingPrompt = signal<string | null>(null);

  set(prompt: string): void {
    const trimmed = prompt.trim();
    this.pendingPrompt.set(trimmed.length > 0 ? trimmed : null);
  }

  /** Returns and clears any pending initial AI prompt. */
  consume(): string | null {
    const prompt = this.pendingPrompt();
    this.pendingPrompt.set(null);
    return prompt;
  }

  clear(): void {
    this.pendingPrompt.set(null);
  }
}
